module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "story",
    attrs: {
      "id": "CreatingMissionalCulture-3.html",
      "xml:lang": "en-US",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('h2', {
    staticClass: "Title",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Part One")]), _vm._v(" "), _c('p', {
    staticClass: "part-title-2",
    attrs: {
      "xml:lang": "fr-FR"
    }
  }, [_vm._v("The Power of Culture")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }), _vm._v(" "), _c('p', {
    staticClass: "Body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43f7b8a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Part1.vue
// module id = 81
// module chunks = 0